import React from 'react';
import { NavLink } from 'react-router-dom';

const DTRSubNav = ({ role, handleSettingCurrentPage, departments, adjustments }) => {

    if (role === 'admin') {
        return (
            <ul>
                <li><NavLink to="dtr/my-dtr" onClick={() => handleSettingCurrentPage('dtr')}>My DTR</NavLink></li>
                <li><NavLink to="dtr/pay-periods" onClick={() => handleSettingCurrentPage('dtr')}>Pay Periods</NavLink></li>
                <li><NavLink to="dtr/shift-schedules" onClick={() => handleSettingCurrentPage('dtr')}>Shift Schedules</NavLink></li>
                <li><NavLink to="dtr/shifts" onClick={() => handleSettingCurrentPage('dtr')}>Shifts</NavLink></li>
                <li><NavLink to="dtr/timesheets" onClick={() => handleSettingCurrentPage('dtr')}>Timesheets</NavLink></li>
            </ul>
        );
    }

    if (role === 'manager') {
        return (
            <ul>
                <li><NavLink to="dtr/my-dtr" onClick={() => handleSettingCurrentPage('dtr')}>My DTR</NavLink></li>
                <li><NavLink to="dtr/shift-schedules" onClick={() => handleSettingCurrentPage('dtr')}>Shift Schedules</NavLink></li>
                <li><NavLink to="dtr/timesheets" onClick={() => handleSettingCurrentPage('dtr')}>Timesheets</NavLink></li>
            </ul>
        );
    }

    if (role === 'supervisor') {
        return (
            <ul>
                <li><NavLink to="dtr/my-dtr" onClick={() => handleSettingCurrentPage('dtr')}>My DTR</NavLink></li>
                <li><NavLink to="dtr/shift-schedules" onClick={() => handleSettingCurrentPage('dtr')}>Shift Schedules</NavLink></li>

                {departments?.length > 0 || adjustments?.length > 0 && (<li><NavLink to="dtr/timesheets" onClick={() => handleSettingCurrentPage('dtr')}>Timesheets</NavLink></li>)}
            </ul>
        );
    }

    if (role === 'staff') {
        return (
            <ul>
                <li><NavLink to="dtr/my-dtr" onClick={() => handleSettingCurrentPage('dtr')}>My DTR</NavLink></li>
                {/* ISB-1273: Shift Schedules access for staff - commented out per user request */}
                {/* <li><NavLink to="dtr/shift-schedules" onClick={() => handleSettingCurrentPage('dtr')}>Shift Schedules</NavLink></li> */}

                {departments?.length > 0 || adjustments?.length > 0 && (<li><NavLink to="dtr/timesheets" onClick={() => handleSettingCurrentPage('dtr')}>Timesheets</NavLink></li>)}
            </ul>
        );
    }

    if (role === 'management') {
        return (
            <ul>
                <li><NavLink to="dtr/timesheets" onClick={() => handleSettingCurrentPage('dtr')}>Timesheets</NavLink></li>
            </ul>
        );
    }

    return null;
}

export default DTRSubNav;
